export const TABLE_CELL_DEFAULT_MARGIN = 20;
